import React from "react";
import Form from "../../components/Form/Form";
import FormBooking from "../../components/Form/FormBooking";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProtectedPage from "../ProtectPage/ProtectedPage";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
const Booking = () => {
  const path = useParams();
  const { user } = useSelector((state) => state.user || {});
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!user) {
      dispatch(setAuthModalOpen(true));
    }
  }, [user, dispatch]);

  if (!user) return null;

  return <FormBooking path={path} user={user} />;
};
export default Booking;
